import ApplicationSerializer from 'eflex/serializers/application';

export default class KineticAssemblyOperationSerializer extends ApplicationSerializer {
  attrs = {
    assembly: {
      deserialize: false,
      serialize: false,
    },
  };
}
